import ImportData from '@/components/custom/ImportData'

export default {
  components: {
    ImportData,
  },

  props: {
    id: String,
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      form: null,
      isRenderContent: true,
      invalid: false,
    }
  },

  computed: {
    isDisabledSaveBtn() {
      return this.invalid || this.form == null
    },
  },

  methods: {
    reRender() {
      this.isRenderContent = false
      setTimeout(() => {
        this.isRenderContent = true
      }, 100)
    },
    handleClose () {
      this.$emit('onClose')
      this.reRender()
    },
    handleChange(form) {
      this.form = form
    },
    convertDateISOString(dateString) {
      if (dateString == null) {
        return null
      }
      const arr = dateString.split('/')
      const dateStr = `${arr[2]}/${arr[1]}/${arr[0]}`
      return new Date(dateStr).toISOString()
    },
    convertNumber(numberString) {
      return numberString ? Number(numberString) : null
    },
    convertMapStatus(value, mapString) {
      if (value == null) {
        return null
      }
      const statues = mapString.split(',')
      for (const item of statues) {
        const data = item.split(':')
        const localed = data[0]
        const status = data[1]
        if (localed === value) {
          return status
        }
      }
      return null
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/importData.js